<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Parent Role</label>
          <v-select :options="optionMainRole" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.parent_id" name="parent_id" disabled/>
          <span class="text-danger text-sm"  v-show="errors.has('parent_id')">{{ errors.first('parent_id') }}</span>
        </div>

        <vs-input class="w-full mt-4" label="Name" v-model="data_local.name" v-validate="'required'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>   

        <vs-input class="w-full mt-4" label="Description" v-model="data_local.description" v-validate="'required'" name="description" />
        <span class="text-danger text-sm"  v-show="errors.has('description')">{{ errors.first('description') }}</span> 
      </div>
    </div>

    <!-- Permissions -->
    <vx-card class="mt-base" no-shadow card-border>
        <table class="w-full">
          <tr>
            <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Module','All', 'Menu', 'Create', 'Read', 'Update', 'Delete']" :key="heading">{{ heading }}</th>
          </tr>

          <tr v-for="(val, id) in optionUserModule">
            <td class="px-3 py-2">{{ val.name }}</td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['all']" @change="checkAll(val.val)"></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['list']" :class="{'checkTrue': isCheck}"></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['create']"></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['read']"></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['update']"></vs-checkbox>
            </td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="data_local_p[val.val]['delete']"></vs-checkbox>
            </td>
          </tr>
        </table>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submit('a')" :disabled="!validateForm">Save and New</vs-button>
          <vs-button class="ml-4 mt-2" @click="submit('b')" :disabled="!validateForm">Save and Close</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../../axios'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      token: localStorage.usertoken,

      optionMainRole: [],
      optionUserModule: [],

      data_local_p: {},
      isCheck: false,

      //role
      data_local: {
        parent_id: parseInt(this.$route.params.viewId),
        property_id: '',
        name: ''
      },

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    submit(loc) {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes(loc)
        }
      })
    },
    async save_changes(loc) {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = -1
      const viewId = this.$route.params.viewId
      const sv = await axios.post(`/role/save/${editId}`, {
        data: this.data_local,
        mainRoleId: viewId,
        token: this.token
      })

      const sp = await axios.post(`/permission/save/${editId}`, {
        data: JSON.stringify(this.data_local_p),
        user_role_id: sv['data']['id'],
        token: this.token
      })

      if(
          (sp['data'] != 'access_denied' && sp['data'] != '')
        ) {

        if(sp['data'] == 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Data Saved',
            text: 'The selected data was successfully saved'
          })

          if (loc=='a') {
            setTimeout(() => {
              window.location.href = "/roles/new";
            },500)
          } else {
            this.$router.push({name:'app-role-list'})
          }

        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Saving Data',
            text: 'Something went wrong'
          })
        }

      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Error loading',
          text: 'Something went wrong'
        })
        
        this.$router.push({name:'app-role-list'})
      }
      
    },
    reset_data () {
      //role
      this.data_local['parent_id'] = ''
      this.data_local['property_id'] = ''
      this.data_local['name'] = ''

      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    loadMainRole () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/mainRole/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {   
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res main role ', res)        
        this.optionMainRole = res
      })
    },
    loadUserModule () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/userModule/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res user module ', res)
        this.optionUserModule = res

        for (var data in res) {
          var user_module_val = res[data]['val']

          this.data_local_p[user_module_val] = {
            all: false,
            list: false,
            create: false,
            update: false,
            read: false,
            delete: false,
          }          
        }

      })
    },
    checkAll(id) {
      this.data_local_p[id]['list'] = this.data_local_p[id]['all'] == true ? true : false
      this.data_local_p[id]['create'] = this.data_local_p[id]['all'] == true ? true : false
      this.data_local_p[id]['read'] = this.data_local_p[id]['all'] == true ? true : false
      this.data_local_p[id]['update'] = this.data_local_p[id]['all'] == true ? true : false
      this.data_local_p[id]['delete'] = this.data_local_p[id]['all'] == true ? true : false
      this.isCheck = !this.isCheck
    }
  },
  created () {
    this.loadMainRole()
    this.loadUserModule()
  }
}
</script>
